import React from 'react';
import Select from 'react-select';
import Toaster from 'toastr';
import { connect } from 'react-redux';
import { Permissioned } from 'react-permissions';
import Messages from '../../../configurations/messages';
import Permissions from '../../../configurations/permissions';
import Util from '../../../util/util';
import ArbiterApi from '../../../api/ArbiterApi';
import Modal from '../../common/modal';
import FloatInput from '../../common/floatInput';
import CButton from '../../common/connectedButton';

class ReasonCodesModal extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isNew: props.isNew,
            isView: !props.isNew,
            reasonCode: props.isNew ? {} : props.reasonCode,
            categories: [],
            title: props.isNew ? "New Reason Code" : `${props.reasonCode.name}`,
            updating: false,
            touchedForm: false,
            categoryValidity: -1,
            nameValidity: -1,
            codeValidity: -1,
            descriptionValidity: 1

        };

        this.modalStyle = {
            ovelay: {},
            content: {
                top: "80px",
                left: "250px",
                right: "250px",
                zIndex: "1000"
            }
        }
        this.onTextInputChange = this.onTextInputChange.bind(this);
        this.onCategoryChange = this.onCategoryChange.bind(this);
    }

    onTextInputChange(evt) {

        let reasonCode = Object.assign({}, this.state.reasonCode);
        reasonCode[evt.target.id] = evt.target.value || null;
        
        let stateUpdate =  {
             reasonCode,
            touchedForm: true,
        }
        stateUpdate[`${evt.target.id}Validity`] =  evt ? 1 : 0;

        this.setState(stateUpdate);
    }
    onCategoryChange(evt) {
        let reasonCode = Object.assign({}, this.state.reasonCode);
        reasonCode.disputeCategory = evt ? evt.value : null;

        this.setState({
            reasonCode,
            category: evt,
            touchedForm: true,
            categoryValidity : evt ? 1: 0

        });
    }
    componentDidMount() {

        if (this.state.isNew) {
            ArbiterApi.getDisputeCategories()
                .then(response => {
                    let selectedCategory = null;
                    let categories = response.data.map(obj => {

                        obj.label = obj.category;
                        obj.value = obj.category;
                        obj.statuses = obj.statuses.map(status => {
                            return {
                                label: status,
                                value: status,
                            };
                        });
                        if (this.state.reasonCode.disputeCategory === obj.category) {
                            selectedCategory = obj;
                        }
                        return obj;

                    });
                    this.setState({ categories, category: selectedCategory });
                })
                .catch(error => {
                     Util.errorMessageToast(Toaster, error.data,
                        [` ${Messages.ERROR_DISPUTE_CATEGORIES}`] 
                    );
                    console.log(error);
                })
        }

    }
    handleAction(evt) {
        this.setState({ updating: true });

        const reasonCode = this.state.reasonCode;
        const isNew = this.state.isNew;
        let promise = this.state.isNew ? ArbiterApi.createReasonCode(reasonCode) : ArbiterApi.updateReasonCode(reasonCode.id, reasonCode)
        promise.then((response) => {
            Toaster.success(`Reason Code  '${this.state.reasonCode.name}' - successfully  ${isNew ? 'created' : 'updated'}`);
            this.setState({ updating: false });
            this.props.onRequestClose(evt, true);
        })
            .catch((error) => {
                
                Util.errorMessageToast(Toaster,error.data,[`${error.data ? error.data.description : error.statusText}`,`${Messages.ERROR_REASON_CODE_UPDATE}`]);
                this.setState({ updating: false });
            })
    }


    render() {
        const isNew = this.state.isNew;
        const isView = this.state.isView;
        return (
            <Modal title={this.state.title} isOpen={this.props.isOpen} style={this.modalStyle} onRequestClose={this.props.onRequestClose}>
                {isView &&
                    <div className="mod-content">
                        <form>
                            <div className="row">
                                <div className="col-md-11">
                                    <div className="form-div">
                                        <label>Name:</label>
                                        <label>{this.state.reasonCode.name}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Code:</label>
                                        <label>{this.state.reasonCode.code}</label>
                                    </div>

                                    <div className="form-div">
                                        <label>Category:</label>
                                        <label>{this.state.reasonCode.disputeCategory}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Description:</label>
                                        <label>{this.state.reasonCode.description}</label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                }
                {!isView && 
                <div className="mod-content">
                    <form>
                        <div className="row">
                            <div className="col-md-11">
                                <div className="form-div">
                                    <label className="required">Name</label>
                                    <FloatInput
                                        id="name"
                                        value={this.state.reasonCode.name}
                                        onChange={this.onTextInputChange}
                                        placeholder="Enter Name"
                                        maxLength="50"
                                        showError={this.state.nameValidity === 0} errorMessage={`${Messages.INVALID_NAME}`}
                                    />
                                </div>
                                <div className="form-div">
                                    <label className="required">Code</label>
                                    <FloatInput
                                        id="code"
                                        value={this.state.reasonCode.code}
                                        onChange={this.onTextInputChange}
                                        placeholder="Enter Code"
                                        disabled={!isNew}
                                        maxLength="5"
                                        showError={this.state.codeValidity === 0} errorMessage={`${Messages.INVALID_CODE}`}
                                    />
                                </div>

                                <div className="form-div">
                                    <label className="required">Category</label>
                                    {isNew && <Select
                                        id="category"
                                        value={this.state.category}
                                        options={this.state.categories}
                                        onChange={this.onCategoryChange}
                                        placeholder="Select Category"
                                        disabled={!isNew}

                                    />}
                                    {!isNew &&
                                        <FloatInput
                                            id="category"
                                            value={this.state.reasonCode.disputeCategory}
                                            disabled={true}
                                        />
                                    }
                                </div>
                                <div className="form-div">
                                    <label>Description</label>
                                    <textarea
                                        id="description"
                                        placeholder="Enter description"
                                        onChange={this.onTextInputChange}
                                        value={this.state.reasonCode.description}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                }
                <div className="mod-footer">
                    <div className="mod-footer-buttons">
                        {isView &&
                            <CButton 
                                onClick={(evt) => { this.setState({isView : false}) }} 
                                className="btn btn-primary"
                                allowedPermissions={[Permissions.UPDATE_REASON_CODE]}>EDIT</CButton>
                        }
                        {!isView && isNew &&
                            <CButton 
                                onClick={(evt) => { this.handleAction(evt); }} 
                                disabled={this.state.updating || !this.formValid()} 
                                className="btn btn-primary"
                                allowedPermissions={[Permissions.CREATE_REASON_CODE]}>CREATE</CButton>

                        }
                        {!isView && !isNew &&
                            <CButton 
                                onClick={(evt) => { this.handleAction(evt); }} 
                                disabled={this.state.updating || !this.formValid()} 
                                className="btn btn-primary"  
                                allowedPermissions={[Permissions.UPDATE_REASON_CODE]}>UPDATE</CButton>

                        }
                        <button onClick={(evt) => { this.props.onRequestClose(evt); }} disabled={this.state.updating} className="btn btn-danger">CLOSE</button>
                    </div>
                </div>
            </Modal>
        )
    }

    formValid() {
        if (this.state.isNew)
            //Each field must have an exact validity i.e. validity must exact equal '1'
            return this.state.touchedForm && this.state.nameValidity === 1 && this.state.codeValidity === 1 && this.state.categoryValidity === 1 && this.state.descriptionValidity === 1;
        //all fields must be valid i.e validity must be 1 or -1 (for untouched fields)
        return this.state.touchedForm && this.state.nameValidity && this.state.descriptionValidity;
    }

}

export default connect(Util.defaultMapStateToProps)(Permissioned(ReasonCodesModal, [Permissions.VIEW_REASON_CODE]));


// WEBPACK FOOTER //
// ./src/components/admin/reasonCodes/reasonCodesModal.js